import { FontLoader, Font } from "three/examples/jsm/loaders/FontLoader.js";
import { TextGeometry } from "three/examples/jsm/geometries/TextGeometry.js";
import * as THREE from "three";
import { Context } from "./context";
import { CommonColor } from "./Parameters";

export class TextModel {
  private m_fontAddress: string = "fonts/helvetiker_regular.typeface.json";
  private m_font: Font | undefined;
  private m_context: Context;
  constructor(context: Context) {
    this.m_context = context;
    const loader = new FontLoader();
    let _this = this;
    loader.load(this.m_fontAddress, function (font) {
      _this.m_font = font;
    });
  }

  CreateText(param: { text: string; size?: number; color?: CommonColor }) {
    let { text, size, color } = param;
    let textGeo = new TextGeometry(text, {
      font: this.m_font!,
      size: size || 0.3,
      height: 1,
      curveSegments: 12,
    });
    textGeo.computeBoundingBox();
    textGeo.computeBoundingSphere();
    textGeo.center();
    let material = new THREE.MeshBasicMaterial({
      color: color || CommonColor.White,
    });
    let textMesh = new THREE.Mesh(textGeo, material);
    textMesh.userData = { text: text };
    return textMesh;
  }

}
